(() => {
  'use strict';
  // Legacy body markup remains supported; new covers are rendered by Liquid.
  // Display the player immediately, without autoplay or a separate Load button.
  document.querySelectorAll('[data-sd-youtube-id]').forEach((card) => {
    const id = card.dataset.sdYoutubeId;
    if (!/^[A-Za-z0-9_-]{11}$/.test(id || '') || card.querySelector('iframe')) return;
    const slot = card.querySelector('[data-sd-youtube-slot]');
    if (!slot) return;
    const frame = document.createElement('iframe');
    frame.title = card.dataset.sdYoutubeTitle || 'Independent YouTube review';
    frame.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=0&rel=0`;
    frame.allow = 'accelerometer; encrypted-media; gyroscope; picture-in-picture; web-share';
    frame.referrerPolicy = 'strict-origin-when-cross-origin';
    frame.allowFullscreen = true;
    slot.append(frame);
    const gate = card.querySelector('.sd-review-video__gate');
    if (gate) gate.hidden = true;
    const status = card.querySelector('[data-sd-video-status]');
    if (status) status.textContent = 'Press Play in the YouTube player, or use Watch on YouTube below.';
  });
})();
